<div class="page-content page-fill">
  <div class="grid-fill">
    @if (people) {
      <dx-data-grid #dataGrid [dataSource]="people" keyExpr="Id" [columnAutoWidth]="false" [wordWrapEnabled]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
        <dxi-column dataField="FirstName" width="120" ></dxi-column>
        <dxi-column dataField="LastName" width="120" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
        <dxi-column dataField="Address" width="250" caption="Address" width="300"></dxi-column>
        <dxi-column dataField="CellPhone" width="150"></dxi-column>
        <dxi-column dataField="Email" width="200"></dxi-column>
        <dxi-column dataField="FamilyName" width="200" caption="Family" width="300"></dxi-column>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <!-- <dxo-filter-panel [visible]="true"></dxo-filter-panel> -->
        <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="member-people-grid"></dxo-state-storing>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <!-- <dxo-export [enabled]="true" [allowExportSelectedData]="true" [fileName]="'people'"></dxo-export> -->
        <dxo-selection [mode]="'multiple'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex align-items-center">
          <!-- <dx-button text="Open" type="default" (onClick)="open(peopleGrid.focusedRowKey)"></dx-button>
          <dx-button text="Add" type="normal" (onClick)="open()"></dx-button>
          <dx-button text="Add Family" type="normal" (onClick)="add('family')"></dx-button> -->
          <!-- <dx-select-box
          [(value)]="selectedView"
          [items]="['Directory', 'All']"
          [searchEnabled]="false"
          [showClearButton]="false"
          (valueChange)="selectedViewChanged()"
          class="ms-3"
        ></dx-select-box> -->
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (people) {
          <span class="ms-3"
            ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
            >
          }
        </div>
      </dx-data-grid>
    }
  </div>
</div>
